import { IllustrationProps } from 'fe-design-base/assets/types';
import Box from 'fe-design-base/atoms/Box';

import payday from './imageFiles/payday.png';

const Payday = (props: IllustrationProps) => (
  <Box
    w={72}
    {...props}
    minw={72}
    className={`FDBIllustration${
      props?.className ? ` ${props.className}` : ''
    }`}
  >
    <img src={payday} style={{ width: '100%' }} alt="Pay Day Illustration" />
  </Box>
);
export default Payday;
